import React,{useRef, useState, useEffect} from "react";
import { Card, Row, Col, Button, Modal} from "react-bootstrap";
import SearchOwner from "../components/SearchOwner";
import DoNowButton from "../components/DoNowButton";
import atlasApi from "../utils/atlasapi";

class DialogAssociateOwner extends React.Component {

	
	constructor(props) {
		super(props);
		
		this.state = {
			validated: false,
			status: {sent:null, message:''}
		}
		
		
		
		//this.owner = schemas.owner.cast(this.props.owner);
		
	}
	updateStatus(s){
		var x = {...this.state};
		x.status = s;
		this.setState(x);
		this.forceUpdate();
	}

	
	handleExit(){
	
	}
	handleClose(data){
		this.props.onClose(data);
		this.updateStatus({sent:null, message:''});
	};
	handleOnSelect(owner){
		this.props.setup.onSelect(owner);
		this.updateStatus({step:0});
	}
	handleOnPick(owner){
		this.updateStatus({step:2});
	}
	back(e){
		this.updateStatus({step:this.state.step-1});
	}
	handleNoResults(needle){
		if(this.props.setup.onNoResults)
			return this.props.setup.onNoResults(needle);
		return null;
	}
	handleOnShow(needle){
		
	}
	render() {
		
		
		return (


		<Modal show={this.props.setup.open} onHide={(e)=>this.handleClose(e)} onShow={(e)=>this.handleOnShow(e)} centered>
			<Modal.Header closeButton>
				<Modal.Title>Assign owner to property</Modal.Title>
			</Modal.Header>

			
			<Modal.Body>
				<Row className="mt-3">
					
					<Col xs="12" className="text-center">
						<SearchOwner hideIcon onPick={(oId)=>{this.handleOnPick(oId)}} onNoResults={(needle)=>{return this.handleNoResults(needle)}} onSelect={(oId)=>{this.handleOnSelect(oId)}} />
					</Col>							
				</Row>
			</Modal.Body>
					
			
		</Modal>
		);
	}
}

export default DialogAssociateOwner;